import styled from 'styled-components';

export const SortWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 225px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const SortSelect = styled.select`
  display: none;
`;

export const SortOption = styled.div<{ $selected?: boolean }>`
  padding: 12px 20px;
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.palette.secondary.background : 'transparent'};

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const SortRadio = styled.div<{ $active?: boolean }>`
  width: 18px;
  height: 18px;
  border: 2px solid
    ${({ $active, theme }) =>
      $active ? theme.palette.brand.main : theme.palette.secondary.border};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ $active, theme }) =>
      $active ? theme.palette.brand.main : 'transparent'};
  }
`;

export const SortPopupContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const SortLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  padding: 0 15px;
  font-size: 15px;
  border-radius: 9px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const SortRadioWrapper = styled.div`
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SortDropdown = styled.div<{ $isSortOpen?: boolean }>`
  position: relative;
  border-radius: 14px;
  border: 1px solid
    ${({ $isSortOpen, theme }) =>
      $isSortOpen ? theme.palette.brand.main : theme.palette.secondary.border};
  background: ${({ theme }) => theme.palette.primary.background};
  height: 45px;
  padding: 15px 15px 15px 40px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  cursor: pointer;

  background-image: url(${({ $isSortOpen }) =>
    $isSortOpen ? '/images/shops/sort.svg' : '/images/shops/sort-closed.svg'});
  background-repeat: no-repeat;
  background-position: 10px 9px;

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.brand.main};
  }

  &::after {
    content: '';
    width: 15px;
    height: 15px;
    background-image: url(${({ $isSortOpen }) =>
      $isSortOpen
        ? '/images/shops/sort-icon.svg'
        : '/images/shops/sort-icon-closed.svg'});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-left: auto;
  }
`;

export const SortPopup = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background: ${({ theme }) => theme.palette.primary.background};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  padding: 10px 0;
  z-index: 100;
  min-width: 240px;
`;

export const SortMobileButton = styled.button`
  white-space: nowrap;
  flex-shrink: 0;
  padding: 10px 15px;
  background: ${({ theme }) => theme.palette.secondary.background};
  border: none;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 40px;
  background-image: url('/images/shops/sort-closed.svg');
  background-repeat: no-repeat;
  background-position: center;
`;

export const SortOptionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
  font-size: 16px;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};

  color: ${({ theme }) => theme.palette.primary.labels};

  &:last-child {
    border-bottom: none;
  }
`;

export const MobileSortAndCategories = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow-x: hidden;
  width: 100%;
`;

export const SortOptionRadio = styled.div<{ $active: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid
    ${({ $active, theme }) =>
      $active ? theme.palette.brand.main : theme.palette.secondary.border};
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ $active, theme }) =>
      $active ? theme.palette.brand.main : 'transparent'};
  }
`;

export const CategoriesSortWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;

export const CategoryTag = styled.button<{ $isActive?: boolean }>`
  padding: 11px 20px;
  height: 40px;
  border-radius: 20px;
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.brand.main : theme.palette.secondary.background};
  color: ${({ $isActive, theme }) =>
    $isActive
      ? theme.palette.primary.background
      : theme.palette.primary.labels};
  border: none;
  cursor: pointer;
  font-size: 15px;
  white-space: nowrap;
  flex: 0 0 auto;

  &:hover {
    background: ${({ theme }) => theme.palette.brand.main};
    color: ${({ theme }) => theme.palette.primary.background};
  }
`;

export const CategoriesScrollContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  padding: 0;
  width: 100%;
  max-width: 100%;

  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 15px;
  }
`;

export const CategoriesScrollButton = styled.button<{
  $side: 'left' | 'right';
  $hidden?: boolean;
}>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
  position: absolute;
  top: 50%;
  transform: translateY(-50%)
    ${({ $side }) => ($side === 'right' ? ' rotate(180deg)' : '')};
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: 1000;
  pointer-events: auto;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: none;
  background-image: url('/images/shops/button.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 35px;
`;

export const AdsGrid = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 32px;
  justify-content: center;

  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 480px) and (max-width: 630px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 631px) and (max-width: 785px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 786px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 15px;
    margin-top: 20px;
  }
`;

export const CategoryTagLink = styled.a`
  padding: 11px 20px;
  height: 40px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.secondary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  border: none;
  cursor: pointer;
  font-size: 15px;
  white-space: nowrap;
  flex: 0 0 auto;

  &:hover {
    background: ${({ theme }) => theme.palette.brand.main};
    color: ${({ theme }) => theme.palette.primary.background};
  }
`;
